export const toString = (value: any): string | null => {
  if (typeof value === 'string') {
    return value;
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'number') {
    return value.toString();
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (Array.isArray(value)) {
    return null;
  }
  if (typeof value === 'object') {
    return null;
  }
  return null;
};
export const toBoolean = (value: any): boolean | null => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'number') {
    if (value === 1) {
      return true;
    }
    if (value === 0) {
      return false;
    }
    return null;
  }
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase();
    if (['1', 'on', 'yes', 'true'].includes(lowerValue)) {
      return true;
    }
    if (['0', 'off', 'no', 'false'].includes(lowerValue)) {
      return false;
    }
    return null;
  }
  return null;
};
export const toInt = (value: any): number | null => {
  if (typeof value === 'number' && !isNaN(value)) {
    return Math.trunc(value);
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'string') {
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue)) {
      return parsedValue;
    }
  }
  return null;
};
export const toFloat = (value: any): number | null => {
  if (typeof value === 'number') {
    return value;
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'string') {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
      return parsedValue;
    }
  }
  return null;
};
export const toDate = (value: any): Date | null => {
  if (value instanceof Date) {
    return value;
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'number') {
    return new Date(value);
  }
  if (typeof value === 'string') {
    const parsedValue = new Date(value);
    if (!isNaN(parsedValue.getTime())) {
      return parsedValue;
    }
  }
  return null;
};
